import { type FC, type SVGProps } from 'react';

type SvgFc = FC<SVGProps<SVGSVGElement>>;

export const WhySgSecurityTechnologyCardIcon: SvgFc = (props) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 24.0001V6.66675"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 17.3333C17.6305 16.6407 16.0015 14.4686 16 12C15.9985 14.4686 14.3695 16.6407 12 17.3333"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.464 8.66664C24.3049 7.21034 24.1451 5.3836 23.0642 4.09537C21.9833 2.80714 20.2121 2.33253 18.6318 2.90771C17.0516 3.48288 15.9999 4.985 16 6.66664C16 4.985 14.9483 3.48288 13.3681 2.90771C11.7879 2.33253 10.0167 2.80714 8.93574 4.09537C7.85483 5.3836 7.69508 7.21034 8.53597 8.66664"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.996 6.83325C25.584 7.24157 26.8959 8.35767 27.5535 9.85972C28.2111 11.3618 28.1412 13.0828 27.364 14.5266"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 24.0001C26.4138 24 28.5266 22.3787 29.1514 20.0471C29.7761 17.7156 28.757 15.2551 26.6667 14.0481"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6227 23.3105C26.8773 25.2808 26.0158 27.2292 24.3871 28.3667C22.7584 29.5042 20.6324 29.6422 18.8703 28.7247C17.1083 27.8073 16.0021 25.9865 16 23.9999C15.9979 25.9865 14.8918 27.8073 13.1297 28.7247C11.3676 29.6422 9.24168 29.5042 7.61295 28.3667C5.98423 27.2292 5.12271 25.2808 5.37736 23.3105"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00002 24.0001C5.58622 24 3.4734 22.3787 2.84866 20.0471C2.22391 17.7156 3.243 15.2551 5.33336 14.0481"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00399 6.83325C6.41596 7.24157 5.10402 8.35767 4.44645 9.85972C3.78888 11.3618 3.85878 13.0828 4.63599 14.5266"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSecurityCheckMiniIcon: FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M16.6667 5L7.5 14.1667 3.33333 10"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSecurityBadgeCertifiedIcon: SvgFc = (props) => (
  <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#whySgBadgeCertifiedClip)">
      <path
        d="M11.6667 7.58343C11.6667 10.5001 9.62504 11.9584 7.19837 12.8043C7.0713 12.8473 6.93327 12.8453 6.80754 12.7984C4.37504 11.9584 2.33337 10.5001 2.33337 7.58343V3.5001C2.33337 3.17815 2.59476 2.91677 2.91671 2.91677C4.08337 2.91677 5.54171 2.21677 6.55671 1.3301C6.81202 1.11197 7.18806 1.11197 7.44337 1.3301C8.46421 2.2226 9.91671 2.91677 11.0834 2.91677C11.4055 2.91677 11.6667 3.17793 11.6667 3.5001V7.58343"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 6.99992L6.41667 8.16659L8.75 5.83325"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="whySgBadgeCertifiedClip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhySgSecurityBadgeSslLockIcon: SvgFc = (props) => (
  <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#whySgBadgeSslClip)">
      <path
        d="M2.91667 6.41675H11.0833C11.7272 6.41675 12.25 6.93951 12.25 7.58341V11.6667C12.25 12.3106 11.7272 12.8334 11.0833 12.8334H2.91667C2.27277 12.8334 1.75 12.3106 1.75 11.6667V7.58341C1.75 6.93951 2.27277 6.41675 2.91667 6.41675V6.41675"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.08337 6.41675V4.08341C4.08337 2.47366 5.39029 1.16675 7.00004 1.16675C8.60979 1.16675 9.91671 2.47366 9.91671 4.08341V6.41675"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="whySgBadgeSslClip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhySgSecurityBadgeAiPoweredIcon: SvgFc = (props) => (
  <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#whySgBadgeAiPoweredClip)">
      <path
        d="M6.4266 1.64151C6.47816 1.36543 6.71915 1.16528 7.00001 1.16528C7.28087 1.16528 7.52186 1.36543 7.57343 1.64151L8.18651 4.88368C8.27563 5.35541 8.64461 5.7244 9.11635 5.81351L12.3585 6.4266C12.6346 6.47816 12.8347 6.71915 12.8347 7.00001C12.8347 7.28087 12.6346 7.52186 12.3585 7.57343L9.11635 8.18651C8.64461 8.27563 8.27563 8.64461 8.18651 9.11635L7.57343 12.3585C7.52186 12.6346 7.28087 12.8347 7.00001 12.8347C6.71915 12.8347 6.47816 12.6346 6.4266 12.3585L5.81351 9.11635C5.7244 8.64461 5.35541 8.27563 4.88368 8.18651L1.64151 7.57343C1.36543 7.52186 1.16528 7.28087 1.16528 7.00001C1.16528 6.71915 1.36543 6.47816 1.64151 6.4266L4.88368 5.81351C5.35541 5.7244 5.7244 5.35541 5.81351 4.88368L6.4266 1.64151"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 1.16675V3.50008"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8333 2.33325H10.5"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16669 11.6667C1.16669 12.3106 1.68945 12.8333 2.33335 12.8333C2.97725 12.8333 3.50002 12.3106 3.50002 11.6667C3.50002 11.0228 2.97725 10.5 2.33335 10.5C1.68945 10.5 1.16669 11.0228 1.16669 11.6667H1.16669"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="whySgBadgeAiPoweredClip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhySgSecurityBadge3dsFingerprintIcon: SvgFc = (props) => (
  <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#whySgBadge3dsClip)">
      <path
        d="M6.99997 5.83325C6.35607 5.83325 5.83331 6.35602 5.83331 6.99992C5.83331 7.59492 5.77497 8.46409 5.68164 9.33325"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16665 7.65332C8.16665 9.04165 8.16665 11.375 7.58331 12.8333"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0858 12.2617C10.1558 11.9117 10.3366 10.92 10.3775 10.5"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16669 6.99997C1.16669 4.48912 2.77336 2.25998 5.15536 1.46598C7.53735 0.671984 10.1602 1.49129 11.6667 3.49997"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16669 9.33325H1.17252"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7167 9.33325C12.8333 8.16659 12.7931 6.21009 12.7167 5.83325"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.91669 11.3749C3.20835 10.4999 3.50002 8.74992 3.50002 6.99992C3.49943 6.60259 3.5665 6.20806 3.69835 5.83325"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.04584 12.8334C5.16834 12.4484 5.30834 12.0634 5.37834 11.6667"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 3.96671C6.33325 3.3413 7.66792 3.34151 8.75097 3.96727C9.83402 4.59304 10.5008 5.74922 10.5 7.00005V8.16671"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="whySgBadge3dsClip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhySgSecurityBannerMetricShieldIcon: SvgFc = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20 13C20 18 16.5 20.5 12.34 21.95C12.1222 22.0238 11.8855 22.0202 11.67 21.94C7.5 20.5 4 18 4 13V5.99996C4 5.44805 4.44808 4.99996 5 4.99996C7 4.99996 9.5 3.79996 11.24 2.27996C11.6777 1.90603 12.3223 1.90603 12.76 2.27996C14.51 3.80996 17 4.99996 19 4.99996C19.5523 4.99996 20 5.44768 20 5.99996V13"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSecurityBannerMetricLockIcon: SvgFc = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5 11H19C20.1038 11 21 11.8962 21 13V20C21 21.1038 20.1038 22 19 22H5C3.89617 22 3 21.1038 3 20V13C3 11.8962 3.89617 11 5 11V11"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11V7C7 4.24042 9.24042 2 12 2C14.7596 2 17 4.24042 17 7V11"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSecurityBannerMetricSecuredIcon: SvgFc = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.586 17.414C2.2109 17.789 2.00011 18.2976 2 18.828V21C2 21.552 2.44808 22 3 22H6C6.55192 22 7 21.552 7 21V20C7 19.4481 7.44808 19 8 19H9C9.55192 19 10 18.552 10 18V17C10 16.4481 10.4481 16 11 16H11.172C11.7024 15.9999 12.211 15.7891 12.586 15.414L13.4 14.6C16.2622 15.5971 19.4336 14.4836 21.0444 11.9162C22.6551 9.3487 22.2776 6.00877 20.1344 3.8656C17.9913 1.72244 14.6513 1.34494 12.0839 2.95568C9.51641 4.56642 8.40296 7.73782 9.4 10.6L2.586 17.414"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 7.5C16 7.77596 16.224 8 16.5 8C16.776 8 17 7.77596 17 7.5C17 7.22404 16.776 7 16.5 7C16.224 7 16 7.22404 16 7.5Z"
      fill="currentColor"
    />
    <path
      d="M16 7.5C16 7.77596 16.224 8 16.5 8C16.776 8 17 7.77596 17 7.5C17 7.22404 16.776 7 16.5 7C16.224 7 16 7.22404 16 7.5V7.5"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSecurityBannerMetricMonitoredIcon: SvgFc = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 7V5C3 3.89617 3.89617 3 5 3H7"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 3H19C20.1038 3 21 3.89617 21 5V7"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 17V19C21 20.1038 20.1038 21 19 21H17"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 21H5C3.89617 21 3 20.1038 3 19V17"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 12C11 12.5519 11.4481 13 12 13C12.5519 13 13 12.5519 13 12C13 11.4481 12.5519 11 12 11C11.4481 11 11 11.4481 11 12V12"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.944 12.33C19.0187 12.1164 19.0187 11.8837 18.944 11.67C17.7924 8.84823 15.0477 7.00391 12 7.00391C8.95225 7.00391 6.20758 8.84823 5.05599 11.67C4.9813 11.8837 4.9813 12.1164 5.05599 12.33C6.20758 15.1518 8.95225 16.9962 12 16.9962C15.0477 16.9962 17.7924 15.1518 18.944 12.33"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSecurityStatPciMedalIcon: SvgFc = (props) => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.636 17.1865L22.656 28.5545C22.7023 28.8286 22.5737 29.1027 22.3332 29.2423C22.0928 29.3818 21.791 29.3574 21.576 29.1812L16.8027 25.5985C16.3294 25.245 15.6799 25.245 15.2067 25.5985L10.4253 29.1799C10.2105 29.3558 9.90917 29.3801 9.66889 29.241C9.4286 29.1019 9.29971 28.8284 9.34534 28.5545L11.364 17.1865"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.6665C8 15.0818 11.5847 18.6665 16 18.6665C20.4153 18.6665 24 15.0818 24 10.6665C24 6.25118 20.4153 2.6665 16 2.6665C11.5847 2.6665 8 6.25118 8 10.6665H8"
      stroke="currentColor"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgSecurityShieldAlertStatIcon: SvgFc = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22s8-4 8-10V6l-8-4-8 4v6c0 6 8 10 8 10ZM12 8v4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={12} cy={16} r={1} fill="currentColor" />
  </svg>
);

export const WhySgSecurityGlobeStatIcon: SvgFc = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
